import Crud from "../helpers/crud";

const crud = new Crud("advertisement");
const BANKARI_ORGANIZATION = "Bankári";

const withOrganizationFilter = (query = "") => {
    const params = new URLSearchParams(String(query || "").replace(/^\?/, ""));

    if (!params.has("organization") && !params.has("organizacia"))
        params.set("organization", BANKARI_ORGANIZATION);

    const serializedParams = params.toString();

    return serializedParams ? `?${serializedParams}` : "";
};

export default {
    state() {
        return {
            ...crud.state,

            choices: null,
            residentialBuilding: null,
            locality: null,
            broker: null,
            detailRequest: 0,
        }
    },

    namespaced: true,

    actions: {
        ...crud.actions,

        async fetchObject(context, {id, query}) {
            context.commit('beginDetailRequest');
            const request = context.state.detailRequest;
            const response = (await this.$api.get(`advertisement/${id}/${withOrganizationFilter(query)}`)).data;
            if (request !== context.state.detailRequest) return;

            //Chceme ešte odstrániť všetky "$" v určitých fieldoch, ktoré sú potrebné pre správne zobrazenie detailu nehnuteľnosti
            (() => {
                const parseTexts = (texts) => {
                    if (!texts) return [];
                    if (!Array.isArray(texts)) texts = [texts];

                    return texts.filter((item) => typeof item === 'string').map((item) => {
                        item = item.replace(/\$/g, "");
                        return item;
                    });
                }

                response.benefity = parseTexts(response.benefity);
                response.bezprostredne_okolie_nehnutelnosti = parseTexts(response.bezprostredne_okolie_nehnutelnosti);
                response.dispozicie_a_zariadenia = parseTexts(response.dispozicie_a_zariadenia);
                response.stav_a_rekonstrukcie = parseTexts(response.stav_a_rekonstrukcie);

                context.commit("setCurrentObject", response);
            })();

            context.commit("setLocality", response.locality || null);
            context.commit("setBroker", response.makler || null);
            context.commit("initialize");
            const building = response.base_property?.residential_building;
            if (building && typeof building === 'object') context.commit('setResidentialBuilding', building);
            else if (building) {
                this.$api.get(`residential-building/${building}/`).then(({data}) => {
                    if (request === context.state.detailRequest) context.commit('setResidentialBuilding', data);
                }).catch(() => {});
            }
            return response;
        },

        async fetchObjectsForMap({commit}, query) {
            const objects = (await this.$api.get("advertisement/map/" + withOrganizationFilter(query))).data;

            commit("setObjects", objects);
        },

        async initialize({dispatch}) {
            await dispatch("fetchChoices");
        },

        async fetchChoices(context) {
            const promises = [this.$api.get("flat-advertisement/choices/"), this.$api.get("house-advertisement/choices/"), this.$api.get("land-advertisement/choices/"), this.$api.get("commercial-advertisement/choices/")];
            const data = await Promise.all(promises);

            const allChoices = {};

            data.forEach((item) => {
                allChoices[item.config.url.split("-")[0]] = item.data;
            });

            context.commit("setChoices", {
                type: [
                    {value: "flat", label: "Byt"},
                    {value: "house", label: "Dom"},
                    {value: "land", label: "Pozemok"},
                    {value: "commercial", label: "Komerčný priestor"}
                ],
                allChoices,
            });
        },

        async addInterested(context, {contactData, advertisement}) {
            const currentAdvertisement = advertisement || context.getters["getCurrentObject"];
            const advertisementType = currentAdvertisement.base_property.resourcetype.toLowerCase();

            await this.$api.post(
                `${advertisementType}-advertisement/${currentAdvertisement.id}/public-add-zaujemca/`,
                {...contactData, source: "bankari"}
            );
        },
    },

    mutations: {
        beginDetailRequest(state) {
            state.detailRequest++;
            state.initialized = false;
            state.currentObject = null;
            state.locality = null;
            state.broker = null;
            state.residentialBuilding = null;
        },
        setChoices(state, payload) {
            state.choices = payload;
        },
        setResidentialBuilding(state, payload) {
            state.residentialBuilding = payload;
        },
        setLocality(state, payload) {
            state.locality = payload;
        },
        setBroker(state, payload) {
            state.broker = payload;
        },

        ...crud.mutations,
    },

    getters: {
        ...crud.getters,

        getChoices(state) {
            return state.choices;
        },
        getResidentialBuilding(state) {
            return state.residentialBuilding;
        },
        getLocality(state) {
            return state.locality;
        },
        getBroker(state) {
            return state.broker;
        }
    }
}
